export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9114.87187f3a.jpg";